import api from '../auth/apiClient';
import { HotspotResponse, HotspotFilterState } from '../types/hotspots';

export class HotspotsApiService {
    static async getHotspots(filters: HotspotFilterState = {}): Promise<HotspotResponse> {
        try {
            const params = Object.entries(filters).reduce((acc, [key, value]) => {
                if (
                    value !== undefined &&
                    value !== null &&
                    (typeof value !== "string" || value.trim() !== "")
                ) {
                    acc[key] = value;
                }
                return acc;
            }, {} as Record<string, string>);

            console.log("Fetching hotspots with params:", params);

            const response = await api.get('/hotspots/', { params });

            if (response.status !== 200) {
                throw new Error(`HTTP error! Status: ${response.status}`);
            }

            return response.data;
        } catch (error) {
            console.error("Error fetching hotspots:", error);
            throw error;
        }
    }

    static async getHotspotById(id: number) {
        try {
            const response = await api.get(`/hotspots/${id}`);

            if (response.status !== 200) {
                throw new Error(`HTTP error! Status: ${response.status}`);
            }

            return response.data;
        } catch (error) {
            console.error(`Error fetching hotspot ${id}:`, error);
            throw error;
        }
    }
}
